var indentation_default = {
  "indentZero": "HjRUP",
  "indentOne": "TPph-",
  "indentTwo": "vrUWC",
  "indentThree": "RRTBc",
  "indentFour": "_0n9nX",
  "indentFive": "WMhoD",
  "indentSix": "ViMmf"
};
export {
  indentation_default as default
};
//# sourceMappingURL=indentation-scss.js.map
